export function match(arr1: any[], arr2: any[]) {
  // Check if the arrays have the same length
  if (arr1.length !== arr2.length) {
    return false;
  }

  // Iterate over each object in the first array
  for (let i = 0; i < arr1.length; i++) {
    // Find the corresponding object in the second array
    const obj2 = arr2.find(obj => {
      for (const prop in obj) {
        if (obj[prop] !== arr1[i][prop]) {
          return false;
        }
      }
      return true;
    });

    // If a corresponding object is not found, return false
    if (!obj2) {
      return false;
    }
  }

  // If all objects and properties match, return true
  return true;
}

